// extracted by mini-css-extract-plugin
var _1 = "GroupSquarishCard-module__animateUploadProgressBarWidth--kF1CY";
var _2 = "GroupSquarishCard-module__animatedBackground--O72KC";
var _3 = "GroupSquarishCard-module__bannerImage--frPmg";
var _4 = "GroupSquarishCard-module__clockIcon--BcrML";
var _5 = "GroupSquarishCard-module__groupIcon--GXMc0";
var _6 = "GroupSquarishCard-module__groupName--qDgru";
var _7 = "GroupSquarishCard-module__plainBanner--_8Zkp";
export { _1 as "animateUploadProgressBarWidth", _2 as "animatedBackground", _3 as "bannerImage", _4 as "clockIcon", _5 as "groupIcon", _6 as "groupName", _7 as "plainBanner" }
